import React from 'react';
import { BrainCircuitIcon } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function Mechanism() {
  return <section className="py-24 px-6 bg-[#18181b] relative overflow-hidden" data-id="element-99">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-amber-500/5 via-transparent to-transparent opacity-50" data-id="element-100" />

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-101">
        <FadeIn className="flex justify-center mb-8" data-id="element-102">
          <div className="bg-amber-500/10 p-4 rounded-2xl border border-amber-500/20" data-id="element-103">
            <BrainCircuitIcon className="w-12 h-12 text-amber-500" data-id="element-104" />
          </div>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-105">
          <h2 className="font-bebas text-4xl sm:text-5xl uppercase tracking-wide text-center mb-8" data-id="element-106">
            El Método de Reconfiguración de{' '}
            <span className="text-amber-500" data-id="element-107">Receptores D2</span>
          </h2>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-108">
          <div className="prose prose-invert prose-lg max-w-none text-zinc-300" data-id="element-109">
            <p className="mb-6" data-id="element-110">
              En lugar de prohibir, vamos a <strong data-id="element-111">reiniciar</strong>. Este
              protocolo utiliza la neuroplasticidad para bajar tus niveles de
              sobreestimulación de forma controlada.
            </p>
            <p data-id="element-112">
              Al reducir la carga química durante 21 días, obligas a tu cerebro
              a "encender" nuevamente sus receptores de placer natural,
              devolviéndote la energía vital y la claridad que dabas por
              perdidas.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}